import { ApolloClient, gql } from 'apollo-boost';
import { axiosClient } from 'shared/apollo/request';
import { ReportStage, ReportStatus } from '../FeedbackDashboard/api';

export interface Services {
  dbId: number;
  name: string;
  description: string;
  version: 'v4' | null;
}

const servicesQuery = gql`
  query {
    services {
      name
      description
      dbId
      version
    }
  }
`;

export const getServices = (client: ApolloClient<object>) =>
  client.query({
    query: servicesQuery,
    fetchPolicy: 'network-only',
  });

interface ContributionReport {
  currentDirectCash: number;
  currentDirectInKind: number;
  currentIndirectCash: number;
  currentIndirectInKind: number;
  initialDirectCash: number;
  initialDirectInKind: number;
  initialIndirectCash: number;
  initialIndirectInKind: number;
  logo: string | null;
  name: string;
  primaryInterventionType: '{}';
  results: {
    id: number;
    indicator: string;
    forecastCurrent: number;
    claimPercentage: number;
  }[];
  service: string | null;
  stage: ReportStage;
  status: ReportStatus;
  program: {
    email: string;
    firstName: string;
    lastName: string;
    logo: string | null;
    name: string;
  };
}

interface ContributionAllocation {
  amount: number;
  createdAt: string;
  id: number;
  tasks: {
    id: number;
    type: 'allocate' | 'submit';
    due: string; // '08/23/2024'
    status: 'completed' | 'overdue';
  }[];
  tier: 'Incremental';
  updatedAt: string | null;
  report: ContributionReport;
}

interface ContributionInvitation {
  createdAt: string;
  dt: null;
  email: string;
  firstName: string;
  lastName: string;
  organization: string;
  updatedAt: string | null;
}

export interface ContributionInvestment {
  allocations: ContributionAllocation[];
  cashAmount: number;
  enabled: number;
  goodsAmount: number;
  granteeId: number;
  granteeLogo: null;
  granteeName: string;
  id: number;
  investmentRelationshipFirstName: string;
  investmentRelationshipLastName: string;
  investmentRelationshipManagerEmail: string;
  managerId: number;
  message: string;
  programNameByDonor: string;
  reportDate1: null;
  reportDate2: null;
  reportDate3: null;
  reportDate4: null;
  reportDate5: null;
  reportDate6: null;
  servicesAmount: number;
  status:
    | 'Unnotified'
    | 'Waiting'
    | 'PartiallyAllocated'
    | 'Allocated'
    | 'Published'
    | 'Draft';
  volunteerismAmount: number;
  invitations: ContributionInvitation[];
}

export interface Contribution {
  id: number;
  funderLogo: null;
  investments: ContributionInvestment[];
  mainPortfolio: number | null;
  managerEmail: string;
  managerFirstName: string;
  managerId: number;
  managerLastName: string;
  name: string;
  reportDate1: null;
  reportDate2: null;
  reportDate3: null;
  reportDate4: null;
  reportDate5: null;
  reportDate6: null;
  status: 'Active';
  timelineDays1: null;
  timelineDays2: null;
  timelineDays3: null;
  timelineDays4: null;
  timelineDays5: null;
  timelineDays6: null;
  timelineDays7: null;
  timelineDays8: null;
  timelineFrom1: null;
  timelineFrom2: null;
  timelineFrom3: null;
  timelineFrom4: null;
  timelineFrom5: null;
  timelineFrom6: null;
  timelineFrom7: null;
  timelineFrom8: null;
  year: number;
}

const GET_CONTRIBUTIONS_URL = 'v4/home';
export const getContributions = () => {
  return axiosClient.get<Contribution[]>(GET_CONTRIBUTIONS_URL);
};
